<div class="box p-4">
  @if (themeService.isLoader) {
    <div class="loader-container d-flex align-items-center justify-content-center">
      <div class="loader">
        <app-loader></app-loader>
      </div>
    </div>
  } @else {
    <div
      class="d-flex flex-wrap justify-content-center gap-3 overflow-y-auto crm-scroll"
      [ngClass]="{ 'hidden-scroll': baseService.isMobile }"
      [formGroup]="themeForm"
    >
      @for (theme of themeService.themesPreviews; track theme.name) {
        <label>
          <input
            class="d-none"
            type="radio"
            name="themes"
            [value]="theme.name"
            [formControl]="themeForm.controls.theme"
            (change)="select()"
          />
          <div class="bg-block overflow-hidden border border-black/10" [ngStyle]="themeService.getThemePreviewStyles(theme)">
            @if (theme.colors; as colors) {
              <div class="absolute inset-0 grid grid-cols-2">
                <div [style.background]="colors.background"></div>
                <div [style.background]="colors.surface"></div>
                <div [style.background]="colors.muted"></div>
                <div [style.background]="colors.accent"></div>
              </div>
            }
            <span class="relative z-[2]" [ngStyle]="themeService.getThemePreviewLabelStyles(theme)">
              {{ theme.name }}
            </span>
            @if (theme.has_video) {
              <app-icon class="video-icon">play_circle</app-icon>
            }
            @if (themeForm.controls.theme.value === theme.name) {
              <app-icon class="active-icon">done</app-icon>
            }
          </div>
        </label>
      }
    </div>
    <div class="d-flex justify-content-center gap-3 p-2 w-100 bg-white">
      <app-button [btnType]="'cancel'" (onChangeClick)="cancel()">
        {{ 'cancel' | translate }}
      </app-button>
      <app-button (onChangeClick)="save()">
        {{ 'save' | translate }}
      </app-button>
    </div>
  }
</div>
